import React, { MouseEventHandler } from 'react';

import { Member, Poll, PollResult, PollResultResponse } from '../../../../../types/entity.types';

import Button from '../../../../common/button/Button';
import Modal from '../../../../common/modal/Modal';
import ProfilePicture from '../../../../common/profile-picture/ProfilePicture';

import BadgesContainer from '../../../../../containers/badges/Badges.container';

import { ReactComponent as TrophyIcon } from '../../../../../resources/icons/win-trophy.svg';

import './tribe-poll-results.scss';

type Props = {
  poll: Poll;
  results?: PollResultResponse;
  show: boolean;
  close: MouseEventHandler<HTMLButtonElement>;
};

const TribePollResults = ({ poll, results, show, close }: Props) => {
  if (!show) {
    return <React.Fragment />;
  }

  return (
    <Modal show={show}>
      <section className="tribe-poll-results">
        <p className="tribe-poll-results__header">Poll Results</p>
        <section className="tribe-poll-results__content">
          <p className="tribe-poll-results__question">{poll.question}</p>
          <p className="tribe-poll-results__count">
            {results?.votes} of {results?.members} members voted
          </p>

          <section className="tribe-poll-results__results visible-scrollbar">
            {results?.results.map((result, index) => (
              <Result key={result.option} result={result} winner={index === 0} />
            ))}
          </section>

          <Button text="Close" onClick={close} />
        </section>
      </section>
    </Modal>
  );
};

type ResultProps = {
  result: PollResult;
  winner?: boolean;
};

const Result = ({ result, winner }: ResultProps) => (
  <div className="tribe-poll-results__result">
    <div className="tribe-poll-results__option">
      <div className="tribe-poll-results__option__winner">
        {winner && <TrophyIcon />}
        <p>{result.option}</p>
      </div>
      <p>
        {result.votes} {result.votes === 1 ? 'Vote' : 'Votes'}
      </p>
    </div>

    <div className="tribe-poll-results__members">
      {result.members.map((member) => (
        <ResultMember key={member.username} member={member} />
      ))}
    </div>
  </div>
);

type ResultMemberProps = {
  member: Member;
};

const ResultMember = ({ member }: ResultMemberProps) => (
  <div className="tribe-poll-results__member">
    <ProfilePicture src={member.profilePicture} small />
    <p>{member.username}</p>
    <BadgesContainer
      memberReference={member.memberExternalReference}
      badgeReferences={member?.memberBadgeIconExternalReferences ?? []}
    />
  </div>
);

export default TribePollResults;
